module.exports = __webpack_public_path__ + "static/media/29.b8c09944.png";